import React from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import './App.css';
import RideDetails from './pages/RideDetails';


function App() {
  return (
    <Router>
      <Routes>
        <Route exact path='/' element={<RideDetails />} />
      </Routes>
    </Router>
  );
}

export default App;
